import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useOrgActivation } from '@/hooks/useOrgActivation';
import { useUserRole } from '@/hooks/useUserRole';

/**
 * Invisible global gate: auto-activates a user's sole Clerk org membership so an
 * invited / dashboard-provisioned member isn't stranded without an active org
 * (the app scopes every request off the active-org JWT). Multi-org selection is
 * handled explicitly in Onboarding.
 */
export function OrgActivationGate() {
  const { isInternal, isPlatform, loading } = useUserRole();
  const location = useLocation();
  const navigate = useNavigate();
  const customerAutoActivation = !loading && !isInternal && !isPlatform;
  // Cross-tenant control-plane users intentionally operate without tenant context.
  const activation = useOrgActivation({ autoActivate: customerAutoActivation });

  // If automatic recovery fails on an org-scoped page, hand off to the visible
  // picker instead of leaving the user behind an invisible failed gate.
  useEffect(() => {
    if (
      customerAutoActivation
      && activation.isLoaded
      && activation.error
      && location.pathname.startsWith('/app')
    ) {
      navigate('/onboarding', { replace: true });
    }
  }, [
    activation.error,
    activation.isLoaded,
    customerAutoActivation,
    location.pathname,
    navigate,
  ]);

  return null;
}
